// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__3xUvp","active":"NavigationItem_active__1cz8l"};